// extracted by mini-css-extract-plugin
export default {"wrapper":"f5hxJ3CAco9AIfGibDSC","title":"zhKhUXolxYsDJ80LxYc4","report":"qUFVTO7M5udPQ_0GrT_k","report__center":"wU85d6f334EAIraWw4sC"};